import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { useModal } from '../../../../hooks/use-modal';
import { useShipFrom } from '../../../../hooks/ship-froms/use-ship-from';

import { ChildrenPropType } from '../../../../prop-types/children';
import DeleteShipFromModal from '../ship-from-row/delete-ship-from-modal';
import WarningShipFromModal from '../ship-from-row/warning-modal';
import ReturnsWarningShipFromModal from '../ship-from-row/returns-warning-modal';
import { useShipFromPageErrorContext } from './ship-from-page-error-context-provider';

const DeleteShipFromModalContext = React.createContext();
export const useDeleteShipFromModalContext = () => useContext(DeleteShipFromModalContext);

const DeleteShipFromModalContextProvider = ({ children }) => {
  const { open, close, isOpen } = useModal();
  const [shipFromId, setShipFromId] = useState();
  const { isReturnRabbitError, setErrors } = useShipFromPageErrorContext();

  const shipFrom = useShipFrom(shipFromId);

  useEffect(() => {
    const action = shipFrom ? open : close;
    action();
  }, [shipFrom, open, close]);

  const closeModal = useCallback(() => {
    setShipFromId(null);
  }, [setShipFromId]);

  const isDeleteOpen = useMemo(() => {
    return isOpen && shipFromId && !shipFrom?.isDefault;
  }, [shipFrom?.isDefault, isOpen, shipFromId]);

  const isWarnOpen = useMemo(() => {
    return isOpen && shipFromId && shipFrom?.isDefault;
  }, [shipFrom?.isDefault, isOpen, shipFromId]);

  const value = useMemo(
    () => ({
      setDeleteShipFromId: setShipFromId,
    }),
    [setShipFromId],
  );

  const closeReturnsWarningModal = useCallback(() => {
    setErrors([]);
  }, [setErrors]);

  return (
    <DeleteShipFromModalContext.Provider value={value}>
      {children}
      {isDeleteOpen && <DeleteShipFromModal onClose={closeModal} shipFromId={shipFromId} />}
      {isWarnOpen && <WarningShipFromModal onClose={closeModal} />}
      {isReturnRabbitError && <ReturnsWarningShipFromModal onClose={closeReturnsWarningModal} />}
    </DeleteShipFromModalContext.Provider>
  );
};

DeleteShipFromModalContextProvider.propTypes = {
  children: ChildrenPropType.isRequired,
};

export default DeleteShipFromModalContextProvider;
